




































































import Vue from 'vue';
import { Level } from '@/store/types';
import LearningTools from '@/tools/learning';
import RoutePaths from '@/router/route_paths';

export default Vue.extend({
  name: 'Levels',
  async mounted(): Promise<void> {
    if (!this.$route.query.noInit) {
      await LearningTools.loadLevels(this.$store);
    }
    this.$store.commit('setMainLoading', false);
  },
  methods: {
    onLevel(level: Level): void {
      this.$store.commit('setPersonalizedCourse', null);
      if (this.isPersonalizedLevel(level)) {
        if (this.$store.getters.userHasAccessToPersonalizedAndReview) {
          this.$router.push(RoutePaths.COURSES_PERSONALIZED);
        } else {
          this.$store.commit('setMobileLinksPopup', true);
        }
      } else if (this.isRapidTestLevel(level)) {
        if (this.$store.getters.isRapidTestAllowed) {
          this.$router.push(RoutePaths.RAPID_TEST_INSTRUCTIONS);
        } else {
          this.$store.commit('setMobileLinksPopup', true);
        }
      } else {
        this.$store.commit('setLevel', level);
        this.$router.push(RoutePaths.UNITS);
      }
    },
    isPersonalizedLevel(level: Level): boolean {
      return level.obj_id === LearningTools.LEVEL_COURSE_PERSONALIZED;
    },
    isRapidTestLevel(level: Level): boolean {
      return level.obj_id === LearningTools.LEVEL_RAPID_TEST;
    },
    isLocked(level: Level): boolean {
      return (this.isPersonalizedLevel(level)
          && !this.$store.getters.userHasAccessToPersonalizedAndReview)
        || (this.isRapidTestLevel(level) && !this.$store.getters.isRapidTestAllowed);
    },
    scoreClass(level: Level): string {
      let result = 'link--text text-center font-weight-medium';
      if (level.score_all) {
        result += ' primary';
      } else {
        result += ' orange';
      }
      return result;
    },
  },
});

